// Sample NFT data for Kanpai Pandas collection
export const sappysealsNFTs = [
  
    {
    id: 'sappy-seals-9968',
    name: 'Sappy Seals #9968',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9968.png',
    price: 1.85
},
{
    id: 'sappy-seals-9967',
    name: 'Sappy Seals #9967',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9967.png',
    price: 0.75
},
{
    id: 'sappy-seals-9966',
    name: 'Sappy Seals #9966',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9966.png',
    price: 2.1
},
{
    id: 'sappy-seals-9965',
    name: 'Sappy Seals #9965',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9965.png',
    price: 0.59
},
{
    id: 'sappy-seals-9964',
    name: 'Sappy Seals #9964',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9964.png',
    price: 1.45
},
    
    {
    id: 'sappy-seals-9963',
    name: 'Sappy Seals #9963',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9963.png',
    price: 1.25
},
{
    id: 'sappy-seals-9978',
    name: 'Sappy Seals #9978',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9978.png',
    price: 0.85
},
{
    id: 'sappy-seals-9962',
    name: 'Sappy Seals #9962',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9962.png',
    price: 1.95
},
{
    id: 'sappy-seals-9977',
    name: 'Sappy Seals #9977',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9977.png',
    price: 0.65
},
{
    id: 'sappy-seals-9971',
    name: 'Sappy Seals #9971',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9971.png',
    price: 1.75
},
{
    id: 'sappy-seals-9961',
    name: 'Sappy Seals #9961',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9961.png',
    price: 2.05
},
{
    id: 'sappy-seals-9981',
    name: 'Sappy Seals #9981',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9981.png',
    price: 0.95
},
{
    id: 'sappy-seals-9976',
    name: 'Sappy Seals #9976',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9976.png',
    price: 1.45
},
{
    id: 'sappy-seals-9970',
    name: 'Sappy Seals #9970',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9970.png',
    price: 1.85
},
{
    id: 'sappy-seals-9980',
    name: 'Sappy Seals #9980',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9980.png',
    price: 0.75
},
{
    id: 'sappy-seals-9960',
    name: 'Sappy Seals #9960',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9960.png',
    price: 2.1
},
{
    id: 'sappy-seals-9993',
    name: 'Sappy Seals #9993',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9993.png',
    price: 0.59
},
{
    id: 'sappy-seals-9979',
    name: 'Sappy Seals #9979',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9979.png',
    price: 1.65
},
{
    id: 'sappy-seals-9969',
    name: 'Sappy Seals #9969',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9969.png',
    price: 1.35
},
{
    id: 'sappy-seals-9959',
    name: 'Sappy Seals #9959',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9959.png',
    price: 1.95
},
{
    id: 'sappy-seals-9915',
    name: 'Sappy Seals #9915',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9915.png',
    price: 0.89
},
{
    id: 'sappy-seals-9973',
    name: 'Sappy Seals #9973',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9973.png',
    price: 1.55
},
{
    id: 'sappy-seals-9991',
    name: 'Sappy Seals #9991',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9991.png',
    price: 2.0
},
{
    id: 'sappy-seals-9958',
    name: 'Sappy Seals #9958',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9958.png',
    price: 0.79
},
{
    id: 'sappy-seals-9914',
    name: 'Sappy Seals #9914',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9914.png',
    price: 1.45
},
{
    id: 'sappy-seals-9975',
    name: 'Sappy Seals #9975',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9975.png',
    price: 1.85
},
{
    id: 'sappy-seals-9990',
    name: 'Sappy Seals #9990',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9990.png',
    price: 0.69
},
{
    id: 'sappy-seals-9972',
    name: 'Sappy Seals #9972',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9972.png',
    price: 1.75
},
{
    id: 'sappy-seals-9913',
    name: 'Sappy Seals #9913',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9913.png',
    price: 2.05
},
{
    id: 'sappy-seals-9989',
    name: 'Sappy Seals #9989',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9989.png',
    price: 0.95
},
{
    id: 'sappy-seals-9955',
    name: 'Sappy Seals #9955',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9955.png',
    price: 1.35
},
{
    id: 'sappy-seals-10000',
    name: 'Sappy Seals #10000',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/10000.png',
    price: 1.99
},
{
    id: 'sappy-seals-9954',
    name: 'Sappy Seals #9954',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9954.png',
    price: 0.89
},
{
    id: 'sappy-seals-9988',
    name: 'Sappy Seals #9988',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9988.png',
    price: 1.65
},
{
    id: 'sappy-seals-9996',
    name: 'Sappy Seals #9996',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9996.png',
    price: 1.15
},
{
    id: 'sappy-seals-9912',
    name: 'Sappy Seals #9912',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9912.png',
    price: 1.85
},
{
    id: 'sappy-seals-9987',
    name: 'Sappy Seals #9987',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9987.png',
    price: 0.75
},
{
    id: 'sappy-seals-9957',
    name: 'Sappy Seals #9957',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9957.png',
    price: 2.1
},
{
    id: 'sappy-seals-9953',
    name: 'Sappy Seals #9953',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9953.png',
    price: 0.59
},
{
    id: 'sappy-seals-9999',
    name: 'Sappy Seals #9999',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9999.png',
    price: 1.95
},
    
    {
    id: 'sappy-seals-9911',
    name: 'Sappy Seals #9911',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9911.png',
    price: 1.45
},
{
    id: 'sappy-seals-9995',
    name: 'Sappy Seals #9995',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9995.png',
    price: 0.85
},
{
    id: 'sappy-seals-9986',
    name: 'Sappy Seals #9986',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9986.png',
    price: 1.75
},
{
    id: 'sappy-seals-9948',
    name: 'Sappy Seals #9948',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9948.png',
    price: 2.05
},
{
    id: 'sappy-seals-9956',
    name: 'Sappy Seals #9956',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9956.png',
    price: 0.95
},
{
    id: 'sappy-seals-9992',
    name: 'Sappy Seals #9992',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9992.png',
    price: 1.35
},
{
    id: 'sappy-seals-9985',
    name: 'Sappy Seals #9985',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9985.png',
    price: 1.95
},
{
    id: 'sappy-seals-9910',
    name: 'Sappy Seals #9910',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9910.png',
    price: 0.65
},
{
    id: 'sappy-seals-9947',
    name: 'Sappy Seals #9947',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9947.png',
    price: 1.55
},
{
    id: 'sappy-seals-9998',
    name: 'Sappy Seals #9998',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9998.png',
    price: 2.1
},
{
    id: 'sappy-seals-9952',
    name: 'Sappy Seals #9952',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9952.png',
    price: 0.79
},
{
    id: 'sappy-seals-9984',
    name: 'Sappy Seals #9984',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9984.png',
    price: 1.45
},
{
    id: 'sappy-seals-9909',
    name: 'Sappy Seals #9909',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9909.png',
    price: 1.85
},
{
    id: 'sappy-seals-9936',
    name: 'Sappy Seals #9936',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9936.png',
    price: 0.69
},
{
    id: 'sappy-seals-9997',
    name: 'Sappy Seals #9997',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9997.png',
    price: 1.75
},
{
    id: 'sappy-seals-9983',
    name: 'Sappy Seals #9983',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9983.png',
    price: 2.05
},
{
    id: 'sappy-seals-9946',
    name: 'Sappy Seals #9946',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9946.png',
    price: 0.95
},
{
    id: 'sappy-seals-9951',
    name: 'Sappy Seals #9951',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9951.png',
    price: 1.35
},
{
    id: 'sappy-seals-9945',
    name: 'Sappy Seals #9945',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9945.png',
    price: 1.99
},
{
    id: 'sappy-seals-9942',
    name: 'Sappy Seals #9942',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9942.png',
    price: 0.89
},
{
    id: 'sappy-seals-9925',
    name: 'Sappy Seals #9925',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9925.png',
    price: 1.65
},
{
    id: 'sappy-seals-9908',
    name: 'Sappy Seals #9908',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9908.png',
    price: 1.15
},
{
    id: 'sappy-seals-9994',
    name: 'Sappy Seals #9994',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9994.png',
    price: 1.85
},
{
    id: 'sappy-seals-9918',
    name: 'Sappy Seals #9918',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9918.png',
    price: 0.75
},
{
    id: 'sappy-seals-9922',
    name: 'Sappy Seals #9922',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9922.png',
    price: 2.1
},
{
    id: 'sappy-seals-9982',
    name: 'Sappy Seals #9982',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9982.png',
    price: 0.59
},
{
    id: 'sappy-seals-9929',
    name: 'Sappy Seals #9929',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9929.png',
    price: 1.95
},
{
    id: 'sappy-seals-9935',
    name: 'Sappy Seals #9935',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9935.png',
    price: 1.45
},
{
    id: 'sappy-seals-9944',
    name: 'Sappy Seals #9944',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9944.png',
    price: 0.85
},
{
    id: 'sappy-seals-9950',
    name: 'Sappy Seals #9950',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9950.png',
    price: 1.75
},
    {
    id: 'sappy-seals-9941',
    name: 'Sappy Seals #9941',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9941.png',
    price: 2.05
},
{
    id: 'sappy-seals-9931',
    name: 'Sappy Seals #9931',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9931.png',
    price: 0.95
},
{
    id: 'sappy-seals-9924',
    name: 'Sappy Seals #9924',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9924.png',
    price: 1.35
},
{
    id: 'sappy-seals-9939',
    name: 'Sappy Seals #9939',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9939.png',
    price: 1.95
},
{
    id: 'sappy-seals-9933',
    name: 'Sappy Seals #9933',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9933.png',
    price: 0.89
},
{
    id: 'sappy-seals-9917',
    name: 'Sappy Seals #9917',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9917.png',
    price: 1.65
},
{
    id: 'sappy-seals-9907',
    name: 'Sappy Seals #9907',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9907.png',
    price: 1.15
},
{
    id: 'sappy-seals-9921',
    name: 'Sappy Seals #9921',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9921.png',
    price: 1.85
},
{
    id: 'sappy-seals-9928',
    name: 'Sappy Seals #9928',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9928.png',
    price: 0.75
},
{
    id: 'sappy-seals-9943',
    name: 'Sappy Seals #9943',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9943.png',
    price: 2.1
},
{
    id: 'sappy-seals-9937',
    name: 'Sappy Seals #9937',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9937.png',
    price: 0.59
},
{
    id: 'sappy-seals-9974',
    name: 'Sappy Seals #9974',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9974.png',
    price: 1.95
},
{
    id: 'sappy-seals-9949',
    name: 'Sappy Seals #9949',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9949.png',
    price: 1.45
},
{
    id: 'sappy-seals-9930',
    name: 'Sappy Seals #9930',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9930.png',
    price: 0.85
},
{
    id: 'sappy-seals-9919',
    name: 'Sappy Seals #9919',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9919.png',
    price: 1.75
},
{
    id: 'sappy-seals-9938',
    name: 'Sappy Seals #9938',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9938.png',
    price: 2.05
},
{
    id: 'sappy-seals-9940',
    name: 'Sappy Seals #9940',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9940.png',
    price: 0.95
},
{
    id: 'sappy-seals-9923',
    name: 'Sappy Seals #9923',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9923.png',
    price: 1.35
},
{
    id: 'sappy-seals-9926',
    name: 'Sappy Seals #9926',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9926.png',
    price: 1.99
},
{
    id: 'sappy-seals-9932',
    name: 'Sappy Seals #9932',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9932.png',
    price: 0.89
},
{
    id: 'sappy-seals-9934',
    name: 'Sappy Seals #9934',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9934.png',
    price: 1.65
},
{
    id: 'sappy-seals-9906',
    name: 'Sappy Seals #9906',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9906.png',
    price: 1.15
},
{
    id: 'sappy-seals-9920',
    name: 'Sappy Seals #9920',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9920.png',
    price: 1.85
},
{
    id: 'sappy-seals-9916',
    name: 'Sappy Seals #9916',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9916.png',
    price: 0.75
},
{
    id: 'sappy-seals-9927',
    name: 'Sappy Seals #9927',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9927.png',
    price: 2.1
},
{
    id: 'sappy-seals-9879',
    name: 'Sappy Seals #9879',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9879.png',
    price: 0.59
},
{
    id: 'sappy-seals-9878',
    name: 'Sappy Seals #9878',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9878.png',
    price: 1.95
},
{
    id: 'sappy-seals-9877',
    name: 'Sappy Seals #9877',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9877.png',
    price: 1.45
},
{
    id: 'sappy-seals-9876',
    name: 'Sappy Seals #9876',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9876.png',
    price: 0.85
},
{
    id: 'sappy-seals-9875',
    name: 'Sappy Seals #9875',
    image: 'https://ipfs.io/ipfs/QmUs4WQP47QKGwzPLjVMmhqTbspJfAC344abDEE2UT52HF/9875.png',
    price: 1.75
}

];
